import * as FileSystem from 'expo-file-system';
import React, { useCallback, useEffect, useState } from 'react';
import { FlatList, TouchableOpacity, Text, Image } from 'react-native';
import PDFListItem from '@/components/PDFListItem';
import { useFocusEffect, useRouter } from 'expo-router';
import { useBoundStore, usePersistBoundStore, usePersistSecureBoundStore } from '@/services/zustand/Store';
import { User } from '@/services/AuthDataTypes';
import { getInfo } from '@/services/FetchFromAPI';
import { Magazine } from '@/services/Datatypes';
import Pdf from 'react-native-pdf';
import { prepareStoredMagazine } from '@/services/pageDownloader';
import { avaiableMagazine } from '@/services/Datatypes.web';

const origin = window.location.origin;

const initEditionFilter = async (user: User | null, sessionEdition: string): Promise<string | null> => {
  if (user) {
    return sessionEdition;
  } else {
    return sessionEdition;
  }
};

const initDateFilter = async (user: User | null, sessionDate: string | null): Promise<string | null> => {
  if (user) {
    return sessionDate;
  } else {
    return sessionDate;
  }
};

const prepareMagazineDataForViewer = async (magazineData: any) => {

  return new Promise((resolve, reject) => {
    const pageInfo: any = magazineData.pageInfo;
    const pageInfoLength = pageInfo.length;
  
    let pageData = [];
  
    for(let a=0; a<pageInfoLength; a++) {
  
      pageData.push({
        'pageTitle': `${pageInfo[a].ressort}`,
        'pageNumber': `${pageInfo[a].pageNumber}`,
        'pdfFile': `${origin}/protected-files/${magazineData.date}/${magazineData.edition}/${pageInfo[a].pageNumber}/${magazineData.date}.ZEITUNG.${magazineData.edition}.${pageInfo[a].pageNumber}_0.pdf`
      });
  
      if(a == (pageInfoLength - 1)) {
        resolve(pageData);
      }
    }
  });

};


export default function Selector() {
  const router = useRouter();
  const [avaiableMagazines, setAvaiableMagazines] = useState<avaiableMagazine[]>([]);
  const [editionFilter, setEditionFilter] = useState<string | null>(null);
  const [dateFilter, setDateFilter] = useState<string | null>(null);
  const [donePreparing, setDonePreparing] = useState<boolean>(false);
  const updateMagazineDataForViewer = useBoundStore(useCallback((state) => state.updateMagazineDataForViewer, []));
  const updateCurrentMagazine = useBoundStore(useCallback((state) => state.updateCurrentMagazine, []));
  const updateNumberOfPages = useBoundStore(useCallback((state) => state.updateNumberOfPages, []));
  const updateCurrentPage = useBoundStore(useCallback((state) => state.updateCurrentPage, []));
  const user = usePersistSecureBoundStore(useCallback((state) => state.user, []));
  const sessionEdition = usePersistBoundStore(useCallback((state) => state.favouriteEdition, []));
  const sessionDate = usePersistBoundStore(useCallback((state) => state.favouriteDate, []));
  const deleteAllStoredMagazines = usePersistBoundStore.getState().deleteAllStoredMagazines;

  /*
  #
  #   DEV KRAM
  #
  */
  //deleteAllStoredMagazines(); console.log("PDFSelector");
  //console.log("pageDownloader - all_stored ", JSON.stringify(getAllStoredEpapers(), null, 2));

  useFocusEffect(
    useCallback(() => {
      let isActive = true;
      let am: avaiableMagazine[] = [];
      const fetchMagazines = async () => {
        //const fetchMagazines = await getInfo();
        
        const infoJsonData: any = await fetch(
          '/web-server-api/getJson',
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              "type": 'infoJson'
            }),
          }
        );
    
        const data = await infoJsonData.json();
        
        if(data) {

            if (isActive) {
              data.jsonData.map((e: any) => {
                am.push({ date: e.publicationDate, edition: e.edition, numberOfPages: e.numberOfPages, pageInfo: e.pageInfo })
              });
            }
            am.sort((a, b) => b.date.localeCompare(a.date));
            setAvaiableMagazines(am);
        }
        else {
            return;
        }
      };

      fetchMagazines();

      return () => {
        isActive = false;
      };
    }, [])
  );

  useEffect(() => {
    const fetchEditionFilter = async () => {
      let favouriteEdition, favouriteDate = null;
      favouriteEdition = await initEditionFilter(user, sessionEdition);
      //favouriteDate = await initDateFilter(user, sessionDate);
      setEditionFilter(favouriteEdition);
      //setDateFilter(favouriteDate);
    };

    fetchEditionFilter();
  }, [user, sessionEdition, sessionDate]);

  const clearfilters = () => {
    setDateFilter(null);
  };

  const filterMagazines = (dateFilter: string | null, editionFilter: string | null) => {

    const data = avaiableMagazines.filter(magazine => {
      const dateMatches = dateFilter ? magazine.date === dateFilter : true;
      const editionMatches = editionFilter ? magazine.edition === editionFilter : true;
      return dateMatches && editionMatches;
    });

    return data;
  };

  const handleButtonPress = async (date: string, edition: string, numberOfPages: number, pageInfo: Array<Object> | null) => {

    const magazineData = { date, edition, numberOfPages, pageInfo };

    await prepareStoredMagazine(magazineData);
    const magazineDataForViewer: any = await prepareMagazineDataForViewer(magazineData);

    updateMagazineDataForViewer(magazineDataForViewer);
    updateCurrentMagazine({ date, edition, numberOfPages, pageInfo });
    updateNumberOfPages(numberOfPages);
    updateCurrentPage(1);
    router.navigate(`../PDFViewer`);
  };

  const renderItem = ({ item, index }: { item: avaiableMagazine, index: number }) => (
    <PDFListItem
      index={index}
      date={item.date}
      edition={item.edition}
      numberOfPages={item.numberOfPages}
      pageInfo={item.pageInfo}
      image={null}
      handleButtonPress={handleButtonPress}
    />
  );

  return (
    <>
      <FlatList
        data={filterMagazines(dateFilter, editionFilter)}
        renderItem={renderItem}
        keyExtractor={(item, index) => index.toString()}
      />
      {(dateFilter) && (<TouchableOpacity style={{ alignSelf: 'center', height: 90, }} onPress={clearfilters}><Text style={{ fontSize: 26, color: '#999' }}>Filter löschen</Text></TouchableOpacity>)}
    </>
  );
}